import { useUser } from "@/app/context/UserContext";
import { iDatacenter, iDataCenterDoc, iProProjectMain } from "@/app/models/interfaceProject";
import {  FilePlus2, HardDrive, Link } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import DatacenterList from "./DatacenterList";
import DatacenterUpload from "./DatacenterUpload";
import QaSave from "./QaSave";
import { AlertType, OriginFile, TypeEnvironment, TypeFile, TypeLayout } from "@/app/constants/enums";
import RowEditExcel from "./RowEditExcel";
import { useConfig } from "@/app/context/ConfigContext";
import { chatbotDownloadFileDatacenter } from "@/app/services/charbotDownloadFileDatacenter";
import DriveIcon from "../Elements/Icon/DriveIcon";
import Dropdown from "../Elements/Dropdown";
import { authorizeGoogleDrive } from "@/app/helpers/firebase";
import { useGoogleDrive, WORD_TYPES } from "@/app/hooks/useGoogleDrive";
import { iDriveMetadata, iParamFile } from "@/app/models/drive";
import Loading from "../Elements/Loading";
import { addVersionToFileName } from "@/app/helpers/functions";
import DatacenterUploadGoogleDrive from "./DatacenterUploadGoogleDrive";
import { getDriveMetadata } from "@/app/services/driveService";
import { iResponseType } from "@/app/models/interfaceResponse";


export default function ListSourceEdit() {
  const { typeLayout, userProject,setUserProject,addAlert,userDrive, setUserDrive, user, setUser} = useUser();
    const [isOpenFileUpload, setIsOpenFileUpload] = useState(false);
    const [update, setUpdate] = useState(0);
    const forceUpdate = () => setUpdate((prev) => prev + 1);
    const [idView, setIdView] = useState<string>("qa");
    const { queryParams} = useConfig();
    const [isEditingForm, setIsEditingForm] = useState(true);    
    
    useEffect(() => {  
      if(userProject.project.env == TypeEnvironment.Prod){ 
        setIsEditingForm(false);
      } 
    }, []);


    const handleUpload = (file: iDataCenterDoc) => {
        if(file.type==TypeFile.Qa){
          setIsOpenFileUpload(false);
          setIdView("qa");
          return; 
        }

        if(file.file_origin != OriginFile.Drive &&  userProject.datacenter?.files.filter(O=>O.name === file.name).length){
          addAlert("Archivo cargado con anterioridad", AlertType.Warning);
          return;
        } 
        setUserProject((prevProject: iProProjectMain) => {
          const existingDatacenter = prevProject.datacenter;
          const datacenter: iDatacenter = existingDatacenter || {
            embedding: "",
            embedding_source: "",
            database_service: "",
            documents_file_flag: false,
            name: "Nuevo Datacenter",
            database_service_id: "al guardar",
            description: "",
            files: [],
            drive_files: [],
            documents_file: [],
            deleted_qa: false,
          };
          const shouldMarkDeleted =
            paramFile?.file_origin === OriginFile.Drive &&
            file.file_origin === OriginFile.Drive &&
            paramFile?.meta_data?.id === file.drive_id;

          const updatedFiles = shouldMarkDeleted
            ? datacenter.files.map((f) =>
                f.drive_id === file.drive_id
                  ? { ...f, deleted: true }
                  : f
              )
            : datacenter.files;

          return {
            ...prevProject,
            datacenter: {
              ...datacenter,
              files: [...updatedFiles, file],
            },
          };
        });
        setIsOpenFileUpload(false); 
    };

 
    // const handleUpload = (file: iDataCenterDoc) => {        
    //    setFiles([...files, file]);        
    //};

    
    // userProject.datacenter?.files
    const handleDelete = (fileToDelete: iDataCenterDoc) => { 
      setIsLoadingFuente(true);
      const deleted = true;
      //console.log("handleDelete", fileToDelete);
      if (fileToDelete.type === TypeFile.Qa){
        setUserProject((prevProject:iProProjectMain) => ({
          ...prevProject,
          datacenter: {
            ...prevProject.datacenter,
            deleted_qa: deleted,
            files: prevProject.datacenter?.files?.map((file) =>
              file.file_id === fileToDelete.file_id
                ? { ...file, deleted: true }
                : file
            ) || []
          },
          qa:[]
        }));
      }else { 
        if(fileToDelete.file_id){ 
          setUserProject((prevProject:iProProjectMain) => ({
            ...prevProject,
            datacenter: {
              ...prevProject.datacenter,
              files: prevProject.datacenter?.files.map((file) => 
                file.file_id === fileToDelete.file_id
                  ? { ...file, deleted: deleted }
                  : file
              ) || []
            }
          }));
           
        }else{ 
          setUserProject((prevProject:iProProjectMain) => ({
            ...prevProject,
            datacenter: {
              ...prevProject.datacenter,
              files: prevProject.datacenter?.files.filter((file) => file.file_id_local !== fileToDelete.file_id_local 
              ) || []
            }
          }));
        }
      } 
      setIdView("qa");
      forceUpdate(); 
      setIsLoadingFuente(false);
    };

    const handleViewPanel = (fileToReplace: iDataCenterDoc) => {
      
      setIdView(fileToReplace.file_id??"");
      if(fileToReplace.type===TypeFile.Qa){
        setIdView("qa");
      } 
    };

    const handleDownload = async (file: iDataCenterDoc) => {
      //console.log("Descargando archivo new:", file)
    if (!file.file_url) {
      console.warn("El archivo no tiene URL", file)
      return
    }
    if (!file.name){
      console.warn("El archivo no tiene nombre", file)
      return
    }
    try {
      setIsLoadingFuente(true);
      await chatbotDownloadFileDatacenter(
        file.file_url,
        file.name,
        user,
        setUser
      )
    } catch (error) {
      addAlert("Error al descargar el archivo", AlertType.Error);

    } finally {
      setIsLoadingFuente(false);  
    }
      
    }

    


    // DRIVE 
    const buttonFuenteRef = useRef<HTMLButtonElement>(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const openDropdown = () => setIsDropdownOpen(true);
    const closeDropdown = () => setIsDropdownOpen(false); 
    const [paramFile, setParamFile] = useState<iParamFile | null>(null);
    const { openPicker, getFileMetadata, downloadFile, downloadFileDrive } = useGoogleDrive()    
    const [isLoadingFuente, setIsLoadingFuente] = useState(false);
     

    const handleSelectDrive = async () => {
      try {
         setIsLoadingFuente(true);
          let user_drive = userDrive;
          if(!user_drive){
            const userDriveData = await authorizeGoogleDrive();
            setUserDrive(userDriveData);
            user_drive = userDriveData;
          }
          const picked = await openPicker(user_drive);
          if (!picked) {
            return;
          }

          const metadata = await getFileMetadata(user_drive,picked.id);
          const blob = await downloadFileDrive(user_drive,picked.id, metadata.mimeType);
          const isWord = WORD_TYPES.includes(metadata.mimeType as any); 
          const fileName = isWord
            ? metadata.name.replace(/\.(docx?|DOC)$/i, ".pdf")
            : metadata.name;
          const fileType = isWord
            ? "application/pdf"
            : metadata.mimeType;
            
          const file = new File([blob], fileName, {
            type: fileType,
            lastModified: Date.now(),
          });
          const driveFile = {
              file_origin:OriginFile.Drive,
              meta_data:metadata,
              file:file
          } as iParamFile
          setParamFile(driveFile);
          setIsOpenFileUpload(true);
        } catch (e:any) {
          console.error(e);
          addAlert("Error al procesar fuente Google Drive", AlertType.Error);
        } finally {
          setIsLoadingFuente(false);
          closeDropdown()
        }
      };
    
    const handleUpdateDriveFile = async (fileDrive: iDataCenterDoc) => {
      try {
         setIsLoadingFuente(true);
          let user_drive = userDrive;
          if(!user_drive){
            const userDriveData = await authorizeGoogleDrive();
            setUserDrive(userDriveData);
            user_drive = userDriveData;
          }
           
          const metadata = await getFileMetadata(user_drive,fileDrive.drive_id??"");
          
          if(fileDrive.drive_version && metadata.version === fileDrive.drive_version){
            addAlert("La fuente está actualizado", AlertType.Warning);
            return;
          }
          const blob = await downloadFileDrive(user_drive,fileDrive.drive_id??"" , metadata.mimeType);
          const isWord = WORD_TYPES.includes(metadata.mimeType as any); 
          const fileName = isWord
            ? metadata.name.replace(/\.(docx?|DOC)$/i, ".pdf")
            : metadata.name;
          const fileType = isWord
            ? "application/pdf"
            : metadata.mimeType;
          
          const file = new File([blob], addVersionToFileName(fileName, metadata.version), {
            type: fileType,
            lastModified: Date.now(),
          });
          const driveFile = {
              file_origin:OriginFile.Drive,
              meta_data:metadata,
              file:file
          } as iParamFile
          setParamFile(driveFile);
          setIsOpenFileUpload(true);

        } catch (e:any) {
          console.error(e);
          addAlert("Error al actualizar fuente Google Drive", AlertType.Error);
        } finally {
          setIsLoadingFuente(false);
          closeDropdown()
        } 
    };
    
    //DRIVE V2
    const [isOpenGoogleDrive, setIsOpenGoogleDrive] = useState(false);
    const handleUploadDrive = (vFile: iDataCenterDoc) => {
      setUserProject((prevProject: iProProjectMain) => {
        const existingDatacenter = prevProject.datacenter;
        const datacenter: iDatacenter = existingDatacenter || {
          embedding: "",
          embedding_source: "",
          database_service: "",
          documents_file_flag: false,
          name: "Nuevo Datacenter",
          database_service_id: "al guardar",
          description: "",
          files: [],
          //files: [],
          documents_file: [],
          deleted_qa: false,
        };

        return {
          ...prevProject,
          datacenter: {
            ...datacenter,
            files: [
              ...(datacenter.files || []),
              vFile
            ],
          },
        };
      });

      setIsOpenGoogleDrive(false);
      closeDropdown();
    };

    const handleUpdatedDrive = async (fileDrive: iDataCenterDoc) => {
      if (!fileDrive.drive_url || !fileDrive.drive_url.trim()) {
          addAlert("La URL del archivo es obligatoria.", AlertType.Warning);
        return;
      } 
      try {
        setIsLoadingFuente(true);
        const result:iResponseType<iDriveMetadata> = await getDriveMetadata(fileDrive.drive_url.trim(),user,  setUser);
        if (result.success && result.code === 200 && result.data.metadata.version != fileDrive.drive_version){ 
          setUserProject((prevProject:iProProjectMain) => ({
            ...prevProject,
            datacenter: {
              ...prevProject.datacenter,
              files: prevProject.datacenter?.files.map((file) => 
                file.file_id === fileDrive.file_id
                  ? { ...file, updated: true }
                  : file
              ) || []
            }
          })); 
          addAlert("La fuente se actualizó correctamente", AlertType.Success);
        }else{
          addAlert("La fuente está actualizada", AlertType.Success);
        } 
      } catch (error) {
        addAlert("Error al obtener información del archivo. Verifica la URL y los permisos.", AlertType.Warning);
      } finally {
        setIsLoadingFuente(false);
      }
      
      
    };

  return (
    <div className=""
      onClick={(e) => e.stopPropagation()}
      >
        <div className={`flex w-full h-full ${typeLayout === TypeLayout.Personal?" items-center justify-center":" "}`}>
          {typeLayout === TypeLayout.Personal?"":
            <div className="flex w-9/12 n-elevation-1 rounded-lg p-3">
            {idView=="qa"? 
              <QaSave />:
              <RowEditExcel file_id={idView}/>
            } 
          </div>
          }
          
          <div className={`flex flex-col ${typeLayout === TypeLayout.Personal?" w-8/12":" w-3/12 "} n-elevation-1 rounded-lg ml-5 p-3 pt-2`}> 
               

               
               {/*
                <button
                    className={`flex items-center justify-center btn-inca-secondary shadow-md rounded-full transition-colors px-2 py-2 w-full border border-sky-100
                       ${isEditingForm?"hover:bg-sky-100 cursor-pointer":"hidden" } mb-4`}
                    onClick={() => setIsOpenFileUpload(true)}
                    disabled={!isEditingForm}
                  >
                    <FilePlus2 strokeWidth={1} className="w-5 h-5" />
                    <span className="font-medium">Agregar Fuente</span>
                </button> 
                */}
                
                <button
                    className={`flex items-center justify-center btn-inca-secondary shadow-md rounded-full transition-colors px-2 py-2 w-full border border-sky-100
                      ${isLoadingFuente ? "opacity-60 cursor-not-allowed" : "hover:bg-gray-100"}
                      `}
                    ref={buttonFuenteRef}
                    onClick={openDropdown} 
                    disabled={isLoadingFuente}
                  >
                    {isLoadingFuente?
                      <>
                        <Loading w="w-2" h="h-2" className=""/> Obteniendo Fuente
                      </>:
                      <>
                      <FilePlus2 strokeWidth={1} className="w-5 h-5" />
                      <span className="font-medium">Agregar Fuente</span>
                      </> 
                    }
                    
                    
                </button> 

                <Dropdown 
                  isOpen={isDropdownOpen} 
                  onClose={closeDropdown} 
                  buttonRef={buttonFuenteRef}
                  positionPreference="bottom" // Puedes cambiar a "top", "bottom", "left", "right"
                >
                  <div className='w-64 max-h-96 overflow-x-hidden scroll-custom' 
                  onClick={(e) => e.stopPropagation()}
                  >  
                       <ul className="w-full mt-2">
                        <li>
                          <button
                            onClick={() => setIsOpenFileUpload(true)}                            
                            className="w-full flex items-center gap-2 text-left px-4 py-2 hover:bg-gray-100 transition"
                          >
                            <HardDrive className="w-5 h-5 text-blue-500" />
                            Desde Archivo Local
                          </button>
                        </li>{/*}
                        <li> 
                          <button
                            onClick={handleSelectDrive}
                            className="w-full flex items-center gap-2 text-left px-4 py-2 hover:bg-gray-100 transition"
                          >
                            <DriveIcon size={22} />
                            Desde Google Drive 
                          </button>
                        </li>*/}
                        <li> 
                          <button
                            onClick={()=>{setIsOpenGoogleDrive(true)}}
                            className="w-full flex items-center gap-2 text-left px-4 py-2 hover:bg-gray-100 transition"
                          >
                            <DriveIcon size={22} />
                            Desde Google Drive
                          </button>
                        </li>

                        
                      </ul> 
                  </div>
                </Dropdown>
              
              
              <div className="flex ">
                <DatacenterList 
                  files={userProject?.datacenter?.files?.filter(file=>!file.deleted)||[]} 
                  onDelete={handleDelete} 
                  onDownload = {handleDownload} 
                  onEdit={handleViewPanel} 
                  onUpdateDriveFile={handleUpdateDriveFile}
                  onUpdateDrive={handleUpdatedDrive}
                  idView ={idView}
                  isEditingForm={isEditingForm}
                /> 
              </div> 
          </div>
        </div> 
      <DatacenterUpload 
        onUpload={handleUpload} 
        isOpen={isOpenFileUpload} 
        onClose={() => {setIsOpenFileUpload(false); setParamFile(null)}}
        paramFile={paramFile}
      /> 

      <DatacenterUploadGoogleDrive
        isOpen={isOpenGoogleDrive}
        onClose={() => {closeDropdown(); setIsOpenGoogleDrive(false);}}
        onUpload={handleUploadDrive}
      />

    </div>
  );
}
